import { render, staticRenderFns } from "./WardIdleLog.vue?vue&type=template&id=40087594&scoped=true"
import script from "./WardIdleLog.vue?vue&type=script&lang=js"
export * from "./WardIdleLog.vue?vue&type=script&lang=js"
import style0 from "./WardIdleLog.vue?vue&type=style&index=0&id=40087594&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40087594",
  null
  
)

export default component.exports